// ConsentBanner — Google Consent Mode v2 banner shown to EEA visitors only.
// Renders nothing when the visitor is outside the EEA or has already chosen.
import { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';
import { shouldShowBanner, acceptConsent, rejectConsent } from '../lib/consentMode';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Defer to next tick so the inline consent-default script (in index.html)
    // has run and window.__cbIsEEA is populated.
    const t = setTimeout(() => setVisible(shouldShowBanner()), 100);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const accept = () => { acceptConsent(); setVisible(false); };
  const reject = () => { rejectConsent(); setVisible(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="consent-banner"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-4 md:max-w-md z-[80] rounded-xl border border-emerald-500/25 bg-zinc-950/95 backdrop-blur-sm shadow-2xl p-4"
    >
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-emerald-400 shrink-0 mt-0.5" />
        <div className="text-sm text-zinc-200 flex-1">
          <p className="font-semibold mb-1">We use cookies for ads & analytics</p>
          <p className="text-xs text-zinc-400">
            CountBucks uses Google's advertising and analytics cookies to
            measure ad performance and personalize your experience. You can
            reject non-essential cookies without losing core functionality.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 mt-3">
        <Button size="sm" variant="ghost" onClick={reject} data-testid="consent-reject">
          Reject non-essential
        </Button>
        <Button size="sm" onClick={accept} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="consent-accept">
          Accept all
        </Button>
      </div>
    </div>
  );
}
